<template>
  <kinesis-container class="image-container">
    <img class="placeholder" :src="cow" style="opacity:0" alt="" height="200" />
    <kinesis-element
      tag="img"
      :src="cow"
      height="200"
      alt=""
      :strength="-2 * strength"
      :type="type"
      axis="x"
    />
    <kinesis-element
      tag="img"
      :src="spider"
      height="200"
      alt=""
      :strength="-1 * strength"
      :type="type"
      axis="x"
    />
    <kinesis-element
      tag="img"
      :src="sheep"
      height="200"
      alt=""
      :strength="2 * strength"
      :type="type"
      axis="x"
    />
    <kinesis-element
      tag="img"
      :src="ladybug"
      height="200"
      alt=""
      :strength="1 * strength"
      :type="type"
      axis="x"
    />
    <kinesis-element
      tag="img"
      :src="fennec"
      height="200"
      alt=""
      :strength="1 * strength"
      type="depth"
      @mouseenter.native="entered"
      @mouseleave.native="left"
    />
    <!-- <kinesis-element tag="h3" class="photographic"
      >Photographic</kinesis-element
    >
    <kinesis-element tag="h3" class="encounters" :strength="-10"
      >Encounters</kinesis-element
    > -->
    <kinesis-element
      class="instagram-container"
      :strength="strength * 1.5"
      type="depth"
      tag="a"
      href="https://www.instagram.com/aminerman/"
      target="_blank"
    >
      <img :src="instagram" height="40" alt="" class="instagram" />
      <p>@aminerman</p>
    </kinesis-element>
  </kinesis-container>
</template>

<script>
import { KinesisContainer } from "vue-kinesis";
import { KinesisElement } from "vue-kinesis";
import cow from "@/assets/cow.jpg";
import ladybug from "@/assets/ladybug.jpg";
import spider from "@/assets/spider.jpg";
import fennec from "@/assets/fennec.jpg";
import sheep from "@/assets/sheep.jpg";
import instagram from "@/assets/instagram.svg";
import anime from "animejs";

export default {
  components: {
    KinesisContainer,
    KinesisElement
  },
  data() {
    return {
      cow,
      ladybug,
      spider,
      fennec,
      sheep,
      instagram,
      type: "rotate",
      strength: 0
    };
  },
  methods: {
    entered(e) {
      this.strength = 10;

      anime({
        targets: e.target,
        boxShadow:
          "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
        easing: "easeOutQuint"
      });
    },
    left(e) {
      this.strength = 0;
      anime({
        targets: e.target,
        boxShadow:
          "0px 0px 0px rgba(0, 0, 0, 0.19), 0 0px 0px rgba(0, 0, 0, 0.23)",
        easing: "easeOutQuint"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 50% 300% !important;
  border-radius: 10px;
}

.instagram:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transform: scale(1.05);
}

// img:hover + * {
//   box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
// }

img.placeholder {
  position: relative;
}

.image-container {
  position: relative;
  width: 200px;
  margin: auto;
  text-align: center;
}

.photographic,
.encounters {
  color: white;
  font-size: 24px;
  position: absolute;
  transition: all 300ms;
}

h3 {
  transition: all 300ms;
}

.photographic {
  top: 30%;
  left: -50%;
}

.encounters {
  top: 60%;
  right: -50%;
}

.instagram {
  position: relative;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.19), 0 0px 0px rgba(0, 0, 0, 0.23);
  transition: all 500ms;
}

.instagram-container {
  margin-top: 20px;
  text-align: center;
  display: block;
}

a {
  color: white;
  text-decoration: none;
  display: inline-block;
}
</style>
